import React from "react";
import { DADATA_TOKEN } from "../constants/enums";
import Grow from "@material-ui/core/Grow";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import throttle from "lodash/throttle";

class MaterialAddressSuggest extends React.Component {

    state = {
        value: this.props.input.value,
        suggestions: [],
        listOpened: false,
        currentItem: -1
    };

    onBlur = () => {
        const { input } = this.props;
        input.onBlur();
        setTimeout(this.onListClose, 200);
    };

    onListClose = () => this.setState({ listOpened: false });

    onFocus = (e) => this.props.input.onFocus();

    onChange = (value) => this.props.input.onChange(value);

    pickSuggestion = (suggestion) => {
        this.onListClose();
        this.setState({ value: suggestion.value });
    }
    handleKeyDown = (e) => {
        const code = e.keyCode;
        const { currentItem, suggestions } = this.state;
        if([40,38,13].includes(code)) {
            e.preventDefault();
            if(suggestions.length > 0) {
                if(code === 40) {
                    this.setState({ currentItem: Math.min(currentItem + 1, suggestions.length-1) })
                }
                if(code === 38) {
                    this.setState({ currentItem: Math.max(0, currentItem - 1) })
                }
                if(code === 13) {
                    this.setState({ value: suggestions[currentItem].value });
                    this.onListClose();
                }
            }
        } else {
            this.setState({ currentItem: -1 });
        }
    }

    componentDidUpdate() {
        this.onChange(this.state.value);
    }
    fetchSuggestions = () => {
        const { value } = this.state;
        if(value.length < 2) return;
        if (this.xhr) {
           this.xhr.abort();
        }
        this.xhr = new XMLHttpRequest();
        this.xhr.open("POST", "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address?5");
        this.xhr.setRequestHeader("Accept", "application/json");
        this.xhr.setRequestHeader("Authorization", `Token ${DADATA_TOKEN}`);
        this.xhr.setRequestHeader("Content-Type", "application/json");
        this.xhr.send(JSON.stringify({
            query: value,
            count: 10
        }));

       this.xhr.onreadystatechange = () => {
           if (this.xhr.readyState !== 4) {
               return;
           }
           if (this.xhr.status === 200) {
               const responseJson = JSON.parse(this.xhr.response);
               if (responseJson && responseJson.suggestions) {
                   this.setState({
                       listOpened: (responseJson.suggestions||[]).length > 0,
                       suggestions: responseJson.suggestions,
                       currentItem: -1
                   });
               }
           }
       };
    }
    throttledFetchSuggestions = throttle(() => this.fetchSuggestions(), 500)
    change = (e) => {
        const v = e.target.value;
        this.setState({ value: v }, this.throttledFetchSuggestions);
    }

    render() {
        const { meta: { touched, error, warning } = {}, label } = this.props;
        const { suggestions, value, listOpened, currentItem } = this.state;

        return (
            <React.Fragment>
                <TextField error={touched && (Boolean(error || warning))}
                           label={label}
                           rows={5}
                           multiline
                           margin="dense"
                           FormHelperTextProps={{ classes: {error: "input-error"} }}
                           onChange={throttle(this.change, 500)}
                           onFocus={this.onFocus}
                           onBlur={this.onBlur}
                           value={value}
                           InputProps={{ classes: {multiline: "padded-textarea"}}}
                           onKeyDown={this.handleKeyDown}
                           InputLabelProps={{ shrink: true }}
                           helperText={touched && (error || warning) ? error || warning : ""}
                           variant="outlined"
                           fullWidth />
                {listOpened &&
                    <div className="autocomplete-container">
                        <Grow in={listOpened}>
                            <Paper className={`autocomplete-paper autocomplete-paper--wide`}>
                                 {suggestions.map((s, i) => (
                                     <MenuItem selected={currentItem === i} key={i} component="div" onClick={() => this.pickSuggestion(s)}>{s.value}</MenuItem>
                                 ))}
                            </Paper>
                        </Grow>
                    </div>
                }
            </React.Fragment>
        );

    }
}

export default MaterialAddressSuggest;



// WEBPACK FOOTER //
// ./src/components/MaterialAddressSuggest.js